export const tonalityMaxLength = 2;
